import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/app/providers/AuthProvider";
import { LoadingSpinner } from "@/shared/components/LoadingSpinner";
import { isAdminRole } from "@/shared/utils/roles";

export function AdminSectionOutlet() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <LoadingSpinner fullScreen />;
  }

  if (!isAdminRole(user?.role)) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
}
